import { LoaderFunction } from "react-router-dom";
import { FormStep } from "../InteractiveForm";
import { backendApi } from "../../api";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { queryClient } from "../../queryClient";

interface IAgorithmDB {
  algorithm: FormStep;
  title: string;
  uuid: string;
  user_id: number;
}
export interface IAlgorithms {
  forms: IAgorithmDB[];
  hasNext: boolean;
  offset: number;
  limit: number;
}
interface IFetchAlgorithmsInput {
  offset?: number;
  searchQuery?: string;
}

export async function fetchAlgorithms({
  offset,
  searchQuery,
}: IFetchAlgorithmsInput) {
  const response = await backendApi<IAlgorithms>({
    url: "/algorithms/get-algorithm-forms",
    params: { search_term: searchQuery, offset },
  });
  return response;
}

export function infiniteAlgorithmsQuery({
  offset = 0,
  searchQuery = "",
}: IFetchAlgorithmsInput = {}) {
  return infiniteQueryOptions({
    queryKey: ["algorithms", { searchQuery }],
    queryFn: async ({ pageParam }) =>
      (await fetchAlgorithms({ offset: pageParam, searchQuery })).data,
    initialPageParam: offset,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (!lastPage.hasNext) {
        return undefined;
      }
      return lastPageParam + lastPage.limit;
    },
    getPreviousPageParam: (firstPage, _allPages, firstPageParam) => {
      if (firstPageParam === 0) {
        return undefined;
      }
      return Math.max(firstPageParam - firstPage.limit, 0);
    },
  });
}

export const loader: LoaderFunction = async () => {
  const response = await queryClient.fetchInfiniteQuery(
    infiniteAlgorithmsQuery()
  );
  return { response };
};
